import React, { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";

const CourseList = () => {

  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const coursesPerPage = 10;

  //  SEARCH STATE (ADD)
  const [searchType, setSearchType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await Axios.get(`/api/courses`);
      setCourses(res.data);
    } catch (error) {
      console.log("ERROR:", error);
    }
  };

  const handleFilter = () => {
    let filtered = [...courses];

    if (searchType && searchValue) {
      filtered = filtered.filter((course) =>
        course[searchType]
          ?.toString()
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      );
    }

    setFilteredCourses(filtered);
    setIsFiltered(true);
    setCurrentPage(1);
  };

  const handleRemoveFilter = () => {
    setSearchType("");
    setSearchValue("");
    setFilteredCourses([]);
    setIsFiltered(false);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return !isNaN(d) ? d.toISOString().split("T")[0] : "";
  };

  const updateCourse = async () => {
    try {
      if (!editData.id) {
        alert("ID missing!");
        return;
      }

      await Axios.put(`/api/courses/${editData.id}`, editData);

      alert("Course Updated Successfully");
      setShowEditModal(false);
      fetchCourses();

    } catch (error) {
      console.log("UPDATE ERROR:", error);
    }
  };

  const deleteCourse = async (id) => {
    const confirmDelete = window.confirm(
      "⚠️ Do you really want to delete this course?"
    );

    if (!confirmDelete) return;

    try {
      await Axios.delete(`/api/courses/${id}`);
      alert("✅ Course Deleted Successfully");
      fetchCourses();
    } catch (error) {
      console.log("DELETE ERROR:", error.response);
      alert("❌ Delete failed");
    }
  };

  const data = isFiltered ? filteredCourses : courses;

  const indexOfLast = currentPage * coursesPerPage;
  const indexOfFirst = indexOfLast - coursesPerPage;
  const currentCourses = data.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(data.length / coursesPerPage);

  return (
    <div className="container-fluid mt-4">

      <center><h2 className="job-title">COURSE LIST</h2></center>

      {/*  SEARCH PANEL */}
      <div className="search-container" style={{ justifyContent: "center" }}>

        <span><b>Search By :</b></span>

        <select
          className="search-select"
          value={searchType}
          onChange={(e) => setSearchType(e.target.value)}
        >
          <option value="">Select</option>
          <option value="courseName">Course Name</option>
          <option value="level">Level</option>
          <option value="instructor">Instructor</option>
          <option value="category">Category</option>
        </select>

        <input
          type="text"
          placeholder="Search..."
          className="search-input"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />

        <button className="search-btn" onClick={handleFilter}>
          Search
        </button>

        <button className="remove-filter-btn" onClick={handleRemoveFilter}>
          Remove Filter
        </button>

      </div>

      <table className="table table-bordered">
        <thead className="table-dark">
          <tr>
            <th>S.No</th>
            <th>Course Name</th>
            <th>Category</th>
            <th>Level</th>
            <th>Start Date</th>
            <th>Completion %</th>
            <th>Instructor</th>
            <th>Price</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No Courses Found
              </td>
            </tr>
          ) : (
            currentCourses.map((course, index) => (
              <tr key={course.id}>

                <td>{indexOfFirst + index + 1}</td>
                <td>{course.courseName}</td>

<td>
  {course.category || "-"}
</td>

<td>{course.level}</td>

                <td>
                  {course.startDate
                    ? new Date(course.startDate).toLocaleDateString()
                    : "-"}
                </td>

                <td>{course.completionPercent || "0"}%</td>
                <td>{course.instructor || "-"}</td>
                <td>₹ {course.price}</td>

                <td>
                  <div className="d-flex flex-column action-btns">

                    <div className="d-flex">
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => {
                          setSelectedCourse(course);
                          setShowModal(true);
                        }}
                      >
                        View
                      </button>

                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => {
                          setEditData(course);
                          setShowEditModal(true);
                        }}
                      >
                        Edit
                      </button>
                    </div>

                    <div className="d-flex">
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteCourse(course.id)}
                      >
                        Delete
                      </button>

                      <button className="btn btn-primary btn-sm">
                        Statistics
                      </button>
                    </div>

                  </div>
                </td>

              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* PAGINATION */}
      {data.length > 0 && (
        <div className="d-flex justify-content-center mt-3">

          <button
            className="btn btn-dark me-2"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Previous
          </button>

          <span className="mt-2 mx-2">
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="btn btn-dark ms-2"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>

        </div>
      )}

      {/* VIEW MODAL */}
      {showModal && selectedCourse && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>

          <div style={{
            background: "white",
            padding: "25px",
            borderRadius: "8px",
            width: "400px"
          }}>

            <h4>Course Details</h4>

            <p><b>Name:</b> {selectedCourse.courseName}</p>

<p>
  <b>Category:</b>
  {" "}
  {selectedCourse.category || "-"}
</p>

<p><b>Level:</b> {selectedCourse.level}</p>
            <p><b>Instructor:</b> {selectedCourse.instructor || "-"}</p>
            <p><b>Price:</b> ₹ {selectedCourse.price}</p>

            <button
              className="btn btn-danger mt-2"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>

          </div>
        </div>
      )}

      {/*  EDIT MODAL  */}
      {showEditModal && (
        <div style={{
          position:"fixed",
          top:0,
          left:0,
          width:"100%",
          height:"100%",
          background:"rgba(0,0,0,0.5)",
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          zIndex:1000
        }}>

          <div style={{
            background:"white",
            padding:"25px",
            borderRadius:"8px",
            width:"400px"
          }}>

            <h4>Edit Course</h4>

<input
  className="form-control mb-2"
  value={editData.courseName || ""}
  onChange={(e)=>setEditData({...editData,courseName:e.target.value})}
/>

<select
  className="form-control mb-2"
  value={editData.category || ""}
  onChange={(e)=>
    setEditData({
      ...editData,
      category:e.target.value
    })
  }
>

  <option value="">
    Select Category
  </option>

  <option value="Full Stack">
    Full Stack
  </option>

  <option value="Cloud">
    Cloud
  </option>

  <option value="Digital Marketing">
    Digital Marketing
  </option>

  <option value="Artificial Intelligence (AI)">
    Artificial Intelligence (AI)
  </option>

</select>

<input
  className="form-control mb-2"
  value={editData.level || ""}
  onChange={(e)=>setEditData({...editData,level:e.target.value})}
/>

            <div className="d-flex">
              <button className="btn btn-success" onClick={updateCourse}>
                Update
              </button>

              <button
                className="btn btn-danger ms-2"
                onClick={()=>setShowEditModal(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default CourseList;